import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, size, isEmpty } from "lodash";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import CustomButton from "../../Common/CustomButton";
import DetailsContainer from "../../Common/DetailsContainer";
import CapturedPhotosContainer from "../CapturedPhotosContainer";
import FrResultsNew from "./FrResultsNew";
import ProfileViewMatched from "../../Profiles/ProfileView/ProfileViewMatched";
import ProfileLink from "../../Common/ProfileLink";
import WearingMask from "../../Common/WearingMask";
import Loader from "../../Common/Loader";

import { isUnknownProfile } from "../../../utils/profile";
import { formatDate } from "../../../utils/date";
import {
  fetchCreatedByUsers,
  getHumanIdentificationPhotos,
} from "../../../utils/event";

import { human } from "../../../constants/common";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import { fetchPost } from "../../../api/fetch";
import { eventGroupsData } from "../../../constants/eventGroups";
import { isAllowed } from "../../../utils/users";

const styles = {
  container: {
    height: "100%",
  },
  clickableBoxTitle: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const LogDetailsHuman = (props) => {
  const {
    classes,
    log,
    lov,
    refreshLog,
    overriden,
    permissions,
    dbPermissions,
  } = props;

  const [frResultsOpen, setFrResultsOpen] = React.useState(false);
  const [overrideOpen, setOverrideOpen] = React.useState(false);
  const [humanIdentification, setHumanIdentification] = React.useState();
  const [isFetching, setIsFetching] = React.useState();

  const blockEdition = !isEmpty(dbPermissions)
    ? !isAllowed(dbPermissions, "events.update")
    : get(permissions, ["override"]) === false;

  React.useEffect(() => {
    fetchHumanIdentification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [log]);

  const fetchHumanIdentification = async () => {
    setIsFetching(true);
    try {
      let res = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [get(log, ["id"])],
          types: [1],
        },
        data: eventGroupsData,
      });
      res.items = await fetchCreatedByUsers(res.items);
      setHumanIdentification(get(res, ["items", 0]));
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
  };

  if (isFetching) {
    return (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={classes.container}
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Loader noDecoration />
        </Grid>
      </Grid>
    );
  }

  if (size(humanIdentification) === 0) {
    return (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={classes.container}
        alignItems="center"
        justify="center"
      >
        <Grid item>{I18n.get("site_noHumanDetected")}</Grid>
      </Grid>
    );
  }

  return (
    <Grid container direction="column" alignItems="stretch" wrap="nowrap">
      {!isEmpty(overriden) && (
        <Grid
          item
          xs
          className="flexCenter"
          style={{
            justifyContent: "flex-end",
            paddingRight: "10px",
            color: colors.black54,
          }}
        >
          {`${I18n.get("site_overridenBy")} ${get(overriden, [
            "created_by",
          ])}, ${formatDate(get(overriden, ["created_on"]))}`}
        </Grid>
      )}
      <Grid item style={{ height: "30px", marginBottom: "20px" }}>
        <Grid container>
          <Grid item xs={4} />
          <ProfileLink
            profile={get(humanIdentification, ["profile"])}
            overriden={!isEmpty(overriden)}
            type={human}
            score={get(humanIdentification, ["luke_index"])}
            disabled={props.blockLevel2}
          />
          <Grid
            item
            xs={4}
            className="flexCenter"
            style={{
              justifyContent: "flex-end",
              paddingRight: "10px",
              color: colors.black54,
            }}
          >
            <FrResultsNew
              open={overrideOpen}
              onClick={() => setOverrideOpen(true)}
              onClose={() => setOverrideOpen(false)}
              section={props.section}
              rootEventGroup={log}
              humanIdentification={humanIdentification}
              refreshRootEventGroup={refreshLog}
              refreshHumanIdentification={fetchHumanIdentification}
              overriden={get(log, ["overriden"]) ? log : null}
              onlyOverride={true}
              triggerNode={
                <CustomButton
                  variant="contained"
                  color="primary"
                  onClick={() => setOverrideOpen(true)}
                  onClose={() => setOverrideOpen(false)}
                  style={{top : "-5px"}}
                  startIcon={
                    <img
                      src={
                        blockEdition
                          ? images.overrideIconWhite
                          : images.overrideIconGrey
                      }
                      alt="override"
                    />
                  }
                  disabled={false}
                >
                  {I18n.get("site_override")}
                </CustomButton>
              }
              tabs={props.tabs}
              disabled={blockEdition}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ paddingLeft: "10px" }}>
        <WearingMask
          humanIdentificationEventGroup={humanIdentification}
          height={20}
        />
      </Grid>
      <Grid item style={{ marginBottom: "20px" }}>
        <CapturedPhotosContainer
          driver={true}
          photos={getHumanIdentificationPhotos(humanIdentification)}
          //blockLevel2={props.blockLevel2}
          nodeTitle={
            <FrResultsNew
              open={frResultsOpen}
              onOpen={() => setFrResultsOpen(true)}
              onClose={() => setFrResultsOpen(false)}
              section={props.section}
              rootEventGroup={log}
              humanIdentification={humanIdentification}
              refreshRootEventGroup={refreshLog}
              refreshHumanIdentification={fetchHumanIdentification}
              overriden={get(log, ["overriden"]) ? log : null}
              triggerNode={
                <Box
                  component="span"
                  className={
                    blockEdition ? "text-54" : classes.clickableBoxTitle
                  }
                >
                  {I18n.get("site_capturedPhotosFrResults")}
                </Box>
              }
              tabs={props.tabs}
              disabled={blockEdition}
            />
          }
        />
      </Grid>
      {!isUnknownProfile(get(humanIdentification, ["profile", "id"])) && (
        <Grid item>
          <DetailsContainer title={I18n.get("site_matchedProfile")}>
            <ProfileViewMatched
              profileType={1}
              profile={get(humanIdentification, ["profile"])}
              lov={lov}
              photos={get(humanIdentification, ["profile", "images"]) || []}
              disable={{ containerPadding: true, topBar: true }}
              //blockLevel2={props.blockLevel2}
            />
          </DetailsContainer>
        </Grid>
      )}
      {props.powerUserMode && (
        <>
          <Grid item xs></Grid>
          <Grid
            item
            style={{
              textAlign: "right",
              fontSize: "0.875em",
              color: colors.black38,
              paddingRight: "10px",
            }}
          >
            {I18n.get("site_eventGroupId") + " "}
            <span style={{ fontStyle: "italic" }}>
              {props.details.detectionId}
            </span>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default withStyles(styles)(LogDetailsHuman);
